(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horacio-bike-range"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('horacio-bike-range')) {

  // Shared by section instances; only nearby photos are warmed, never the whole catalogue.

  const photos = new Map(), warmQueue = new Set(), pins = new Map();

  let warming = 0;

  const pin = (url, delta) => {

    if (!url) return;

    const count = (pins.get(url) || 0) + delta;

    if (count > 0) pins.set(url, count); else pins.delete(url);

  };

  const prune = () => {

    for (const [url, entry] of photos) {

      if (photos.size <= 12) break;

      if (entry.ready && !entry.owners.size && !pins.has(url)) photos.delete(url);

    }

  };

  const loadPhoto = (url, priority = 'low') => {

    let entry = photos.get(url);

    if (entry) {

      if (priority === 'high' && !entry.ready) entry.image.fetchPriority = 'high';

      return entry;

    }

    const image = new Image();

    entry = { image, ready: false, owners: new Set(), keepWarm: priority === 'low' };

    entry.promise = new Promise((resolve, reject) => {

      entry.cancel = () => {

        image.onload = image.onerror = null;

        image.removeAttribute('src');

        if (photos.get(url) === entry) photos.delete(url);

        reject(new Error('Photo request superseded'));

      };

      image.onload = () => {

        image.decode().catch(() => {}).then(() => {

          entry.ready = true;

          image.onload = image.onerror = null;

          resolve();

          prune();

        });

      };

      image.onerror = () => {

        image.onload = image.onerror = null;

        if (photos.get(url) === entry) photos.delete(url);

        reject(new Error('Photo unavailable'));

      };

    });

    entry.promise.catch(() => {});

    image.decoding = 'async';

    image.fetchPriority = priority;

    photos.set(url, entry);

    image.src = url;

    return entry;

  };

  const pump = () => {

    while (warming < 2 && warmQueue.size) {

      const url = warmQueue.values().next().value;

      warmQueue.delete(url);

      if (photos.has(url)) continue;

      warming++;

      loadPhoto(url).promise.finally(() => { warming--; pump(); }).catch(() => {});

    }

  };

  const warmPhoto = url => {

    if (url && !photos.has(url)) { warmQueue.add(url); pump(); }

  };

  customElements.define('horacio-bike-range', class extends HTMLElement {

    connectedCallback() {

      if (this.controller) return;

      this.controller = new AbortController();

      const signal = this.controller.signal;

      const fine = matchMedia('(hover:hover) and (pointer:fine)');

      const reduced = matchMedia('(prefers-reduced-motion:reduce)');

      this.querySelectorAll('.hp-card').forEach(card => {

        const source = card.querySelector('.hr-catalog');

        if (!source) return;

        let groups;

        try { groups = JSON.parse(source.textContent).filter(group => group.items.length); } catch { return; }

        if (!groups.length) return;

        const byId = Object.fromEntries(groups.map(group => [group.id, group]));

        const owner = {}, indices = {};

        let active = groups[0].id, ticket = 0, start = null, preventClick = false;

        let pending = null, displayedUrl = '', visible = false, warmTimer;

        const image = card.querySelector('img'), bikeLink = card.querySelector('.hp-bike-link');

        const model = card.querySelector('.hp-model'), colour = card.querySelector('.hp-caption small');

        const price = card.querySelector('.hp-price'), view = card.querySelector('.hp-explore');

        const features = card.querySelector('.hp-facts'), pages = card.querySelector('.hp-pages');

        const picture = card.querySelector('.hp-picture');

        const status = document.createElement('span');

        status.className = 'hp-photo-status'; status.hidden = true;

        status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');

        picture.append(status);

        const photoUrl = item => {

          const candidates = item.srcset.split(',').map(candidate => {

            const match = candidate.trim().match(/^(\S+)\s+(\d+)w$/);

            return match ? { url: match[1], width: Number(match[2]) } : null;

          }).filter(Boolean);

          const width = Math.max(180, picture.getBoundingClientRect().width) * Math.min(devicePixelRatio || 1, 2);

          return (candidates.find(candidate => candidate.width >= width) || candidates[candidates.length - 1])?.url || item.src;

        };

        const release = () => {

          if (!pending) return;

          pending.owners.delete(owner);

          if (!pending.owners.size && !pending.keepWarm && !pending.ready) pending.cancel();

          pending = null;

        };

        const setLoading = loading => {

          picture.setAttribute('aria-busy', String(loading));

          picture.classList.toggle('hr-photo-pending', loading);

          status.hidden = !loading;

          if (loading) status.textContent = this.dataset.loadingLabel;

        };

        const warmNeighbours = () => {

          if (!visible || signal.aborted || navigator.connection?.saveData) return;

          const items = byId[active].items, index = indices[active] || 0;

          warmPhoto(photoUrl(items[(index + 1) % items.length]));

          warmPhoto(photoUrl(items[(index + items.length - 1) % items.length]));

          groups.filter(group => group.id !== active).forEach(group => warmPhoto(photoUrl(group.items[indices[group.id] || 0])));

        };

        const scheduleWarm = () => {

          clearTimeout(warmTimer);

          if (visible) warmTimer = setTimeout(warmNeighbours, 350);

        };

        const seedInitial = () => {

          if (!image.complete || !image.naturalWidth || picture.getAttribute('aria-busy') === 'true') return;

          const url = image.currentSrc || image.src;

          if (!photos.has(url)) photos.set(url, { image, ready: true, owners: new Set(), promise: Promise.resolve() });

          if (!displayedUrl) { displayedUrl = url; pin(url, 1); }

          scheduleWarm();

        };

        const show = (animate = false, direction = 1, updateImage = true) => {

          const items = byId[active].items, index = indices[active] || 0, item = items[index];

          const currentTicket = ++ticket, selectedSeries = active;

          card.dataset.series = active; card.dataset.index = String(index);

          card.querySelectorAll('[data-series]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.series === active)));

          model.textContent = item.model; colour.textContent = item.color; price.textContent = item.price;

          const accessible = this.dataset.viewLabel + ' ' + item.model + ' ' + item.color;

          bikeLink.href = item.url; view.href = item.url;

          bikeLink.setAttribute('aria-label', accessible); view.setAttribute('aria-label', accessible);

          const why = card.querySelector('.hp-why'); if (why) why.textContent = byId[active].why || '';
          features.replaceChildren(...item.features.filter(Boolean).map(text => { const element = document.createElement('span'); element.textContent = text.trim(); return element; }));

          pages.replaceChildren(...items.map((_, n) => { const element = document.createElement('span'); element.className = 'hp-dot' + (n === index ? ' hp-active' : ''); return element; }));

          if (!updateImage) {

            card.dataset.displayedIndex = String(index); card.dataset.displayedSeries = active;

            seedInitial(); return;

          }

          const url = photoUrl(item);

          if (pending !== photos.get(url)) release();

          warmQueue.delete(url);

          const entry = loadPhoto(url, 'high');

          pending = entry; entry.owners.add(owner);

          const commit = () => {

            if (ticket !== currentTicket || signal.aborted) return;

            entry.owners.delete(owner); pending = null;

            image.removeAttribute('srcset'); image.src = url; image.alt = item.model + ' — ' + item.color;

            if (displayedUrl !== url) { pin(displayedUrl, -1); pin(url, 1); displayedUrl = url; }

            card.dataset.displayedIndex = String(index); card.dataset.displayedSeries = selectedSeries;

            setLoading(false);

            if (animate && !reduced.matches) {

              image.getAnimations().forEach(animation => animation.cancel());

              image.animate([{ transform: 'translateX(' + direction * 12 + 'px)' }, { transform: 'translateX(0)' }], { duration: 120, easing: 'ease-out' });

            }

            scheduleWarm(); prune();

          };

          if (entry.ready) commit();

          else {

            setLoading(true);

            entry.promise.then(commit).catch(() => {

              if (ticket !== currentTicket || signal.aborted) return;

              entry.owners.delete(owner); pending = null;

              picture.setAttribute('aria-busy', 'false');

              status.hidden = false; status.textContent = this.dataset.errorLabel;

            });

          }

        };

        const choose = id => { if (id !== active && byId[id]) { active = id; show(true); } };

        const move = direction => { const count = byId[active].items.length; indices[active] = ((indices[active] || 0) + direction + count) % count; show(true, direction); };

        card.querySelectorAll('button[data-series]').forEach(button => {

          button.addEventListener('pointerenter', event => { if (fine.matches && event.pointerType === 'mouse') choose(button.dataset.series); }, { signal });

          button.addEventListener('click', () => choose(button.dataset.series), { signal });

        });

        card.querySelector('.hp-prev').addEventListener('click', () => move(-1), { signal });

        card.querySelector('.hp-next').addEventListener('click', () => move(1), { signal });

        card.addEventListener('pointerenter', () => { visible = true; seedInitial(); warmNeighbours(); }, { signal });

        card.addEventListener('focusin', () => { visible = true; seedInitial(); warmNeighbours(); }, { signal });

        bikeLink.addEventListener('pointerdown', event => { if (event.button !== 0 || !event.isPrimary) return; preventClick = false; start = { x: event.clientX, y: event.clientY, id: event.pointerId }; bikeLink.setPointerCapture(event.pointerId); }, { signal });

        bikeLink.addEventListener('pointerup', event => {

          if (!start || start.id !== event.pointerId) return;

          const dx = event.clientX - start.x, dy = event.clientY - start.y; start = null;

          preventClick = Math.abs(dx) > 10 || Math.abs(dy) > 10;

          if (Math.abs(dx) > 28 && Math.abs(dx) > Math.abs(dy) * 1.05) move(dx < 0 ? 1 : -1);

        }, { signal });

        bikeLink.addEventListener('pointercancel', () => { start = null; preventClick = true; }, { signal });

        bikeLink.addEventListener('click', event => { if (preventClick && event.detail !== 0) event.preventDefault(); preventClick = false; }, { signal });

        image.addEventListener('load', seedInitial, { signal });

        const observer = new IntersectionObserver(entries => {

          visible = entries[0].isIntersecting;

          if (visible) seedInitial(); else clearTimeout(warmTimer);

        }, { rootMargin: '100px 0px', threshold: 0.01 });

        observer.observe(card);

        signal.addEventListener('abort', () => {

          ticket++; observer.disconnect(); clearTimeout(warmTimer); release(); pin(displayedUrl, -1); status.remove();

        }, { once: true });

        show(false, 1, card.classList.contains('hr-ready')); card.classList.add('hr-ready');

      });

    }

    disconnectedCallback() { this.controller?.abort(); this.controller = null; }

  });

}




  } catch(e) { console.error(e); }
})();
})();
